import React from "react";
import "./StepBar.css"; // We'll create this CSS file for styling

const StepBar = ({ totalSteps, currentStep, labels = [] }) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

  return (
    <div className="stepbar-container">
      {steps.map((stepIndex) => {
        const isActive = stepIndex <= currentStep;
        const label = labels[stepIndex - 1] || `Step ${stepIndex}`;
        return (
          <div
            key={stepIndex}
            className={`stepbar-step ${isActive ? "active" : ""}`}
          >
            <div className="step-number">{stepIndex}</div>
            <div className="step-label">{label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default StepBar;
